import styled from 'styled-components';

export const PlaceholderWrapper = styled.div`
  svg {
    width: 100%;
    height: 100%%;
  }
`;
